import { render, staticRenderFns } from "./SystemNavItemList.vue?vue&type=template&id=60460133&scoped=true"
import script from "./SystemNavItemList.vue?vue&type=script&lang=js"
export * from "./SystemNavItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60460133",
  null
  
)

export default component.exports